import React, { useEffect, useState } from 'react';
import cx from 'classnames';

import Image from '@plone/volto/components/theme/Image/Image';
import { UniversalLink } from '@plone/volto/components';
import './ImageCarousel.scss';

const firstItem = (value) => (Array.isArray(value) ? value[0] : value);

const getLinkHref = (link) => {
  const value = firstItem(link);
  return value?.['@id'] || value?.href || value || null;
};

const View = ({ data }) => {
  const slides = data?.slides || [];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) return undefined;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [slides.length]);

  if (!slides.length) return null;


  const goPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goNext = () => {
    setCurrentIndex((prev) => (prev + 1) % slides.length);
  };

  const goTo = (index) => {
    setCurrentIndex(index);
  };

  const slide = slides[currentIndex];
  const item  = firstItem(slide?.image);
  const href  = getLinkHref(slide?.link);

  const content = (
    <>
      {item ? (
        <Image
          item={item}
          alt={slide?.alt || ''}
          responsive 
          sizes="(max-width: 900px) 100vw, 1200px"
          loading="lazy"
        />
      ) : null}

      {slide?.text ? (
        <div className="image-carousel__overlay">
          <span className="image-carousel__text">{slide.text}</span>
        </div>
      ) : null}
    </>
  );

  return (
    <div
      className={cx(
        'image-carousel',
        data.borderless && 'is-borderless',
      )}
    >
      <div className="image-carousel__viewport">
        <div className="image-carousel__slide">
          {href ? (
            <UniversalLink href={href}>
              <span className="image-carousel__linkwrap">{content}</span>
            </UniversalLink>
          ) : (
            <div className="image-carousel__linkwrap">{content}</div>
          )}
        </div>
      </div>

      {slides.length > 1 && (
        <div className="image-carousel__controls">
          <button
            type="button"
            className="image-carousel__arrow image-carousel__arrow--left"
            onClick={goPrev}
            aria-label="Previous image"
          >
            ‹
          </button>
          <div
            className="image-carousel__dots"
            role="tablist"
            aria-label="Carousel navigation"
          >

            {slides.map((_, index) => (
              <button
                key={index}
                type="button"
                className={`image-carousel__dot ${index === currentIndex ? 'is-active' : ''}`}
                onClick={() => goTo(index)}
                aria-label={`Go to slide ${index + 1}`}
                aria-current={index === currentIndex ? 'true' : undefined}
              />
            ))}
          </div>

          <button
            type="button"
            className="image-carousel__arrow image-carousel__arrow--right"
            onClick={goNext}
            aria-label="Next image"
          >
            ›
          </button>
        </div>
      )}
    </div>
  );
};

export default View;